import { render, staticRenderFns } from "./TagsProcess.vue?vue&type=template&id=f2784220"
import script from "./TagsProcess.vue?vue&type=script&lang=js"
export * from "./TagsProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports